import * as React from "react";
import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1602_70927)">
      <path
        d="M6 0.375C2.89575 0.375 0.375 2.89575 0.375 6C0.375 9.10425 2.89575 11.625 6 11.625C9.10425 11.625 11.625 9.10425 11.625 6C11.625 2.89575 9.10425 0.375 6 0.375ZM8.21925 3.4635C8.57025 3.114 9.13725 3.114 9.4875 3.4635C9.83775 3.813 9.83775 4.38225 9.4875 4.73175L5.68275 8.5365C5.33325 8.886 4.7655 8.886 4.41525 8.5365L2.5125 6.63375C2.16225 6.28425 2.16225 5.7165 2.5125 5.3655C2.86275 5.016 3.4305 5.016 3.78075 5.3655L5.049 6.63375L8.21925 3.4635Z"
        fill="#13CB75"
      />
    </g>
    <defs>
      <clipPath id="clip0_1602_70927">
        <rect width={12} height={12} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
